const Menu = [
	{ is_header: true, title: 'General Navigation' },
	{ path: '/dashboard', icon: 'fas fa-dashboard', title: 'Dashboard' },
	{ is_header: true, title: 'Quiz Navigation' },
	{ path: '/create-quiz', icon: 'fas fa-circle-plus', title: 'Create Quiz' }, 
	{ path: '/list-quizes', icon: 'fas fa-list', title: 'List Quizes' }, 
	{ is_divider: true }, 
	{ is_header: true, title: 'Song Reels', adminOnly: true }, 
	{ path: '/create-song-reel', icon: 'fas fa-circle-plus', title: 'Create Song Reel', adminOnly: true }, 
	{ path: '/list-song-reels', icon: 'fas fa-circle-plus', title: 'List Song Reels', adminOnly: true },  
	{ is_divider: true }, 
	{ is_header: true, title: 'XVids Navigation', adminOnly: true }, 
	{ path: '/create-xvid', icon: 'fas fa-circle-plus', title: 'Create XVid', adminOnly: true }, 
	{ path: '/list-xvid', icon: 'fas fa-circle-plus', title: 'List XVids', adminOnly: true },
	{ is_divider: true }, 
	{ is_header: true, title: 'Channel Navigation', adminOnly: true }, 
	{ path: '/create-channel', icon: 'fas fa-circle-plus', title: 'Create Channel', adminOnly: true }, 
	{ path: '/list-channels', icon: 'fas fa-list', title: 'List Channels', adminOnly: true },
];
  
  export default Menu;
  